<template>
  <div class="sign-up-result" v-if="true || show">
    <result-head type="success">您已支付成功</result-head>
    <!-- <result-tip>本次报名仅限前30名用户，<br>你可以预约下次的课程，我们将优先发放报名通知</result-tip> -->
    <p class="sign-up-result-desc">
      简单几步即可开始学习哦
    </p>
    <template v-if="wxinfo && !loading">
      <ResultCamp :qrCode="wxinfo"></ResultCamp>
    </template>
    <template  v-if="!wxinfo && !loading">
      <result-focus
        v-if="hasCourseGroup !== null && !isSubscribe"
        :hasCourseGroup="hasCourseGroup"
        :wxinfo="wxinfo"
      />

      <result-list
        :list="list"
        :isSubscribe="isSubscribe"
        @downloadApp="download"
      />
    </template>

    <!-- <result-button>复制公众号</result-button> -->
    <!--<app-button width="400" inlineBlock @click="goLearn">已关注·直接学习</app-button>-->
  </div>
</template>

<script>
import os from '@edu-fe/os'
import keys from 'lodash.keys'
import api from '../lib/api'
import module from '../modules/sign-up-result'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import ResultButton from '../components/Result/ResultButton.vue'
import ResultFocus from '../components/Result/ResultFocus.vue'
import ResultHead from '../components/Result/ResultHead.vue'
import ResultList from '../components/Result/ResultList.vue'
import ResultTip from '../components/Result/ResultTip.vue'
import ResultCamp from '../components/Result/ResultCamp'
import AppButton from '../components/UI/Button'
import { downloadApp } from '@mixins'

export default {
  computed: {
    ...mapState(module.name, keys(module.state())),
    ...mapGetters(module.name, keys(module.getters))
  },
  methods: {
    ...mapMutations(module.name, keys(module.mutations)),
    ...mapActions(module.name, keys(module.actions)),

    goLearn () {
      this.$router.push({
        name: 'sign-up',
        query: {
          courseId: this.$route.query.courseId,
          tabIndex: 1
        }
      })
    }
  },
  beforeRouteLeave (to, from, next) {
    if (to.name === 'pay') {
      next(`/recommend`)
      return
    }
    next()
  },
  beforeCreate () {
    this.$store.registerModule(module.name, module)
  },
  mixins: [downloadApp],
  async created () {
    // 刷新以使 ios 微信环境能识别二维码
    await this.getSubsribe()

    if (!this.$route.query.reloaded) {
      const href = `${location.protocol}//${location.host}${this.$route.fullPath}&reloaded=1`
      location.href = href
    }
    const { orderId, courseId } = this.$route.query

    // 兼容金山贷款不能获取二维码的问题
    // if (os.name === 'loan' && courseId) {
    //   await this.getQrCode(courseId)
    // }

    if (courseId) {
      await this.getQrCode(courseId)
    }

    if (!orderId) {
      // return this.$toast.show({
      //   message: '缺少订单ID'
      // })
      return
    }

    // 暂时注掉赠送代码
    // const { data: shareId } = await api.payment.getGiftId({ orderId })
    // if (shareId) {
    //   this.$router.replace({
    //     name: 'gift',
    //     query: {
    //       shareId
    //     }
    //   })
    // } else {
    //   this.set({ show: true })
    // }

    this.set({ show: true })
  },

  destroy () {
    this.$store.unregisterModule(module.name)
  },
  components: {
    ResultButton,
    ResultFocus,
    ResultHead,
    ResultList,
    ResultTip,
    AppButton,
    ResultCamp
  }
}
</script>

<style lang="scss">
@charset "UTF-8";
@import "../style/main";

.sign-up-result {
  text-align: center;
  &-desc {
    display: flex;
    justify-content: space-around;
    align-items: center;
    color: #999999;
    font-size: rem(26);
    line-height: 1.4;
    margin-bottom: rem(33);
    &::before,&::after {
      content: '';
      display: block;
      width: rem(174);
      height: rem(2);
      background: #D8D8D8;
    }
  }
}
</style>
